import * as React from "react";
import { Button, Flex, Image, Label, Segment, Text } from "@fluentui/react-northstar";
import { initializeIcons } from '@fluentui/react';
import { withTranslation, WithTranslation } from "react-i18next";
import { CommonHelper } from '../../../helpers/common-helper';
import StatusQueueConstants from "../../../constants/status-queue";

interface IQueueInactivedProps extends WithTranslation {
    botWriting1: boolean;
    ancora: string;
    appConfigs: any;
    appSettings: any;
    meetingQueueData: any;
}

const QueueInactivedCard: React.FunctionComponent<IQueueInactivedProps> = props => {
    const localize = props.t;
    initializeIcons();

    const scheduled = props.meetingQueueData.history?.some((history: any) => history?.status == StatusQueueConstants.atendimentoAgendado);

    return (
        <React.Fragment>
            <Flex className="card" gap="gap.medium" styles={{ margin: "4rem 0" }}>
                <img className="logoIcon" src="https://studio365cdn.azureedge.net/balcaovirtual/logov2.svg" />
                <Flex.Item grow>
                    <Segment
                        hidden={props.botWriting1}
                        className="dialog2 dialog"
                        content={
                            <Flex gap="gap.large" column>
                                <Text className="header-text" content={`${localize("AtendimentoEncerrado")}!`} />
                                <span className="header-subtext">{localize('ProtocoloAtendimento')} <span className="highlight">#{props.meetingQueueData.id.substr(props.meetingQueueData.id?.length - 6)}</span></span>

                                <Flex>
                                    <Flex fill column>
                                        <Label
                                            className="endLabel"
                                            content={(
                                                <Flex gap="gap.medium" padding="padding.medium" hAlign="center" column>
                                                    <Text align="center" weight="light" content={localize("AtendimentoInativoFila")} />
                                                    <Button
                                                        hidden={scheduled}
                                                        content={localize("EntrarNovamente")}
                                                        onClick={() => {
                                                            window.location.href = `/meeting/${props.ancora}`;
                                                        }}
                                                        primary
                                                    />
                                                </Flex>
                                            )}
                                        />
                                    </Flex>
                                    {props.appConfigs && props.appConfigs.imgEnd != "" &&
                                        <Flex.Item align="center" className="welcome">
                                            <Image src={props.appConfigs.imgEnd} />
                                        </Flex.Item>
                                    }

                                    {props.appConfigs && props.appConfigs.imgEnd == "" &&
                                        <Flex.Item align="center" className="fila">
                                            <Image src="https://studio365cdn.azureedge.net/balcaovirtual/expired.svg" className="expired" />
                                        </Flex.Item>
                                    }
                                </Flex>

                                <Flex gap="gap.small">
                                    {props.appSettings && props.appSettings.ajudaComoFunciona &&
                                        <Button content={localize("ComoFunciona")} secondary onClick={() => window.open(CommonHelper.checkIfContainHttps(props.appSettings.ajudaComoFunciona), "_blank")} />
                                    }

                                    {props.appSettings && props.appSettings.ajudaPerguntasFrequentes &&
                                        <Button content={localize("PerguntasFrequentes")} secondary onClick={() => window.open(CommonHelper.checkIfContainHttps(props.appSettings.ajudaPerguntasFrequentes), "_blank")} />
                                    }


                                </Flex>
                            </Flex>
                        }
                    />
                </Flex.Item>
            </Flex>
        </React.Fragment>
    );
};

const queueInactivedWithTranslation = withTranslation()(QueueInactivedCard);
export default queueInactivedWithTranslation;